export function Release_3_0() {
  return (
    <div>
      <h2 className="text-sm text-gray-400">Release on: 18 December 2025</h2>
      <h2 className="text-xl font-semibold text-purple-300">Overview</h2>
      <p className="text-gray-200">
        CashMate 3.0 focuses on smoother inventory operations and better mobile usability across the POS experience.
        We added barcode automation and export tooling, tightened cashier ergonomics, and improved trial visibility and dashboard usability.
      </p>

      <h2 className="text-xl font-semibold text-purple-300 mt-6">New Features</h2>
      <h3 className="text-lg font-semibold text-white mt-3">Inventory & Barcodes</h3>
      <ul className="list-disc list-inside">
        <li>Auto-generate EAN-style barcodes for products and variants with uniqueness checks.</li>
        <li>Export all product/variant barcodes to PDF for printing/storage from the Inventory header.</li>
        <li>Variant/product barcodes are tracked for clashes to reduce scanning errors.</li>
        <li>Variants can be defined per product with option names/values enforced in all-caps for clarity.</li>
      </ul>

      <h3 className="text-lg font-semibold text-white mt-3">Cashier Experience</h3>
      <ul className="list-disc list-inside">
        <li>Mobile-friendly cashier header with search toggle beside the title; camera button aligned with the barcode field.</li>
        <li>Toasts remain visible above payment modals so confirmations/errors aren’t hidden by dim overlays.</li>
      </ul>

      <h3 className="text-lg font-semibold text-white mt-3">Discounts</h3>
      <ul className="list-disc list-inside">
        <li>New discount management lets you generate and manage discount codes for campaigns.</li>
        <li>Discount options surface in cashier for quick apply and validation.</li>
      </ul>

      <h3 className="text-lg font-semibold text-white mt-3">Online Ordering</h3>
      <ul className="list-disc list-inside">
        <li>Customers can choose product options/variants when placing online orders.</li>
        <li>Improved flow for selecting items and syncing to cashier for payment.</li>
        <li>Merchants can connect Stripe to enable online payments (FPX, Link, and cards supported).</li>
        <li>Customers can now pay online directly on the online ordering site.</li>
      </ul>

      <h3 className="text-lg font-semibold text-white mt-3">Pricing & Plans</h3>
      <ul className="list-disc list-inside">
        <li>Introduced a refreshed pricing model with clear plan tiers and trial visibility.</li>
        <li>Updated subscription handling to align with the new plans and upgrade paths.</li>
      </ul>

      <h3 className="text-lg font-semibold text-white mt-3">Backup & Restore</h3>
      <ul className="list-disc list-inside">
        <li>Per-company backups/export to CSV for products (with variants), bundles, journal entries, money in/out.</li>
        <li>Imports for products (with variant creation), bundles, journal, and money in/out are now available.</li>
      </ul>

      <h2 className="text-xl font-semibold text-purple-300 mt-6">Resolved Issues</h2>
      <ul className="list-disc list-inside">
        <li>Barcode camera button alignment and overlay toast visibility in cashier flow.</li>
        <li>Dashboard cards were cramped on small screens; now they can be swiped horizontally.</li>
        <li>Online order cancel flow now restores inventory for products and variants (master + variant stock) and removes the preorders/online order entries.</li>
        <li>Online ordering applies variant price deltas in pricing and shows option surcharges (+RM) for transparency.</li>
        <li>Top Selling Products report uses variant-level stock instead of the parent quantity.</li>
        <li>Online order display sorts pickups correctly: “Now” first (oldest first), “Later” by scheduled date/time.</li>
      </ul>

      <h2 className="text-xl font-semibold text-purple-300 mt-6">Known Issues</h2>
      <ul className="list-disc list-inside">
        <li>Desktop browsers without horizontal scroll (no trackpad) may need Shift + scroll or scroll bar to view KPI cards on very narrow windows.</li>
      </ul>

      <h2 className="text-xl font-semibold text-purple-300 mt-6">Compatible Devices</h2>
      <ul className="list-disc list-inside">
        <li>Optimized for desktop and tablet; mobile UI refined for cashier and dashboard.</li>
        <li>Supported on Chrome, Firefox, Safari, and Edge.</li>
      </ul>
    </div>
  );
}
